import { LegalDocumentPage } from "~/features/legal/components/legal-document-page"

export function UserAgreementPage() {
  return <LegalDocumentPage kind="agreement" />
}
